"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEagerEntry = void 0;
var loadBundle_1 = require("../../componentLoader/loadBundle");
var loadAssets_1 = require("../../componentLoader/loadAssets");
var createEnvironmentLoader_1 = require("../../componentLoader/createEnvironmentLoader");
var RegistryError_1 = require("../../errors/RegistryError");
var createStaticComponentsLoaders_1 = require("./createStaticComponentsLoaders");
var registerComponents_1 = require("./registerComponents");
function createEagerEntry(_a) {
    var _this = this;
    var transport = _a.transport, manifests = _a.manifests;
    return function (params) { return __awaiter(_this, void 0, void 0, function () {
        var error, runtimeInfo, tasks;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (params.info) {
                        error = RegistryError_1.createException('Eager registry does not support pre-fetched components info').withDetails('Eager bundles contains both components and their info props');
                        console.warn(error);
                    }
                    runtimeInfo = [];
                    tasks = manifests.map(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var library, manifest, environmentLoader, response, components;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    library = context.library, manifest = context.manifest;
                                    environmentLoader = createEnvironmentLoader_1.createEnvironmentLoader(transport, library.environment);
                                    if (!(manifest && manifest.url && manifest.id)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, loadBundle_1.loadBundleComponents(transport, manifest.id, manifest.url, environmentLoader)];
                                case 1:
                                    response = _a.sent();
                                    if (params.shouldLoadCSSAssets) {
                                        loadAssets_1.loadLibraryAssets(manifest.assets);
                                    }
                                    runtimeInfo.push({
                                        artifactId: context.library.artifactId,
                                        components: response.info,
                                    });
                                    components = createStaticComponentsLoaders_1.createStaticComponentsLoaders(response.components, response.info || {}, manifest, 'host');
                                    registerComponents_1.registerComponents(components, context, {
                                        registerComponent: params.registerComponent,
                                        registerLibrary: params.registerLibrary,
                                    });
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(tasks)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, {
                            info: runtimeInfo,
                        }];
            }
        });
    }); };
}
exports.createEagerEntry = createEagerEntry;
//# sourceMappingURL=createEagerEntry.js.map